import M5APIs from "m5/M5APIs";
import * as config from "../../../_config";

import { makeAutoObservable, action, computed, observable } from "mobx";
import { TaskModel } from "domains/models/TaskModel";
import { EmployeeModel } from "../../../domains/models/EmployeeModel";
import { QuestionModel } from "domains/models/QuestionModel";
import { UserModel } from "domains/models/UserModel";
import { AssessModel } from "domains/models/AssessModel";
import { M5User } from "m5/models/M5User";
import {
  AggregationDone,
  AggregationModel,
} from "domains/models/AggregationModel";

class TaskGradeEditPageStore {
  @observable private _employee: EmployeeModel = {
    id: "",
    email: "",
    names: {
      fullname: "",
    },
    orgCode: " ",
    paid: false,
    status: "",
    tier: "",
    userData: {},
    username: "",
  };
  @observable private _task?: TaskModel;
  @observable private _assess?: AssessModel;
  @observable private _isLoading: boolean = false;
  @observable private _submitted: boolean = false;
  @observable _questionList: QuestionModel[] = [];
  @observable _customQuestionList: QuestionModel[] = [];
  @observable _isQusetionModal: boolean = false;
  @observable _isOpenModal: boolean = false;
  @observable _isCloseModal: boolean = false;
  @observable _score: string = "0";
  @observable _emoji: string = "";
  @observable private _isHTMLOpen: boolean = false;
  @observable userAggreGation: AggregationModel = {
    title: "",
    created: 0,
    type: "AGGREGATION",
    userData: {
      assessList: [],
    },
  };
  @observable _updateMode: boolean = false;
  deleteList: string[] = [];
  createList: QuestionModel[] = [];
  editList: QuestionModel[] = [];
  questionListForCreating: QuestionModel[] = [];

  // TODO: any 수정
  @observable _formik?: any;

  constructor() {
    makeAutoObservable(this);
  }

  @action
  async fetchQuestionList() {
    try {
      const res = await M5APIs.findAllDocs("QUESTION", {
        orderBy: "created",
        orderDirection: "ASC",
        where: {
          filters: [
            {
              condition: "AND",
              field: "subtype",
              compare: "=",
              value: "BASIC",
            },
          ],
        },
      });
      console.log("###fetchQuestionList", res);
      if (res.docs) {
        this._questionList = res.docs as QuestionModel[];
        this._customQuestionList = [];
      }
    } catch (err: any) {
      throw err;
    } finally {
      this._isLoading = false;
    }
  }

  @action
  initQuestionList() {
    this.fetchQuestionList();
  }

  @action
  async fetchQuestionAllList(assess: AssessModel) {
    const res = await M5APIs.findAllDocs("QUESTION", {
      orderBy: "created",
      orderDirection: "ASC",
      where: {
        filters: [
          {
            condition: "AND",
            field: "subtype",
            compare: "=",
            value: "BASIC",
          },
        ],
      },
    });
    console.log(res);
    console.log(assess?.userData.questionList);

    if (assess?.userData.questionList) {
      if (res.docs) {
        const mergedArray = assess?.userData.questionList.concat(
          res.docs as QuestionModel[]
        );

        const ids = new Set(mergedArray.map((obj) => obj.id || obj.tempId));

        const uniqueArray = Array.from(ids).map((id) =>
          mergedArray.find((obj) => obj.id === id || obj.tempId === id)
        );

        this._questionList = (uniqueArray as QuestionModel[]).filter(
          (question: QuestionModel) => question.subtype === "BASIC"
        );
        this._customQuestionList = (uniqueArray as QuestionModel[]).filter(
          (question: QuestionModel) => question.subtype === "CUSTOM"
        );
        console.log(this._customQuestionList);
      }
    }
  }

  @action
  async createQuestion(doc: QuestionModel) {
    try {
      this._isLoading = true;
      await M5APIs.createDocs(config.BUCKET_TASK!, [doc], "STOP");
    } catch (err) {
      throw err;
    } finally {
      this._isLoading = false;
    }
  }

  @action
  async createTempQuestion(doc: QuestionModel) {
    console.log(doc);
    this._customQuestionList = [...this._customQuestionList, doc];
    this.createList = [...this.createList, doc];
  }

  @action
  async deleteQuestion(id: string) {
    try {
      await M5APIs.deleteDoc(config.BUCKET_TASK!, id);
    } catch (err) {
      throw err;
    } finally {
      this._isLoading = false;
    }
  }

  @action
  async updateQuestion(question: QuestionModel) {
    try {
      await M5APIs.updateDocs(config.BUCKET_TASK!, [question], "MERGE");
    } catch (err) {
      throw err;
    } finally {
      this._isLoading = false;
    }
  }

  @action
  async deleteTempQuestion(id: string) {
    this.createList = this.createList.filter(
      (li: QuestionModel) => li.tempId !== id
    );
    this.editList = this.editList.filter(
      (li: QuestionModel) => li.tempId !== id && li.id === id
    );

    this._customQuestionList = this._customQuestionList?.filter(
      (li: QuestionModel) => {
        console.log(li.id, li.tempId, id);
        if (li.id === id || li.tempId === id) {
          this.deleteList.push(id);
        }
        return li.id !== id && li.tempId !== id;
      }
    );
  }

  @action
  changeRating(
    value: number | null,
    question: QuestionModel,
    updateMode: boolean
  ) {
    if (question.subtype === "BASIC") {
      this._questionList = this._questionList?.map((li: QuestionModel) => {
        if (li.id && li.id === question.id) {
          li.userData.rating = Number(value);
          this.editList.push(li);
          li.status = "COMPLETED";
        }
        if (li.tempId && li.tempId === question.tempId) {
          li.userData.rating = Number(value);
          this.editList.push(li);
          li.status = "COMPLETED";
        }

        return li;
      });
    } else {
      this._customQuestionList = this._customQuestionList?.map(
        (li: QuestionModel) => {
          if (li.id && li.id === question.id) {
            li.userData.rating = Number(value);
            if (updateMode) {
              this.editList.push(li);
            }
            li.status = "COMPLETED";
          }
          if (li.tempId && li.tempId === question.tempId) {
            li.userData.rating = Number(value);
            if (updateMode) {
              this.editList.push(li);
            }
            li.status = "COMPLETED";
          }

          return li;
        }
      );
    }
  }

  @action
  async allSave() {
    console.log(this.createList, this.editList, this.deleteList);

    this.questionListForCreating = [
      ...this.questionList,
      ...this.customQuestionList,
    ];
    // return new Promise<void>((resolve, reject) => {
    // this.createList.forEach(async (li: QuestionModel) => {
    //   delete li.tempId;
    //   // await this.createQuestion(li);
    //   // this.createList.pop();
    // });

    // this.deleteList.forEach(async (id: string) => {
    //   // await this.deleteQuestion(id);
    //   // this.deleteList.pop();
    // });

    // this.editList.forEach(async (li: QuestionModel) => {
    //   // await this.updateQuestion(li);
    //   // this.editList.pop();
    // });
    //   console.log(this.createList, this.deleteList);
    //   resolve();
    // });
    // this._questionList , this._tempQuestionList 비교
  }

  @action
  async createTaskAssess(
    values: any,
    like: string,
    userInfo: UserModel,
    visible: "VISIBLE" | "INVISIBLE",
    isDoneAssess?: boolean
  ) {
    try {
      this._isLoading = true;
      if (this.questionListForCreating.length === 0) {
        this.questionListForCreating = [
          ...this.questionListForCreating,
          ...this.questionList,
        ];
      }
      const doc = {
        type: "ASSESS",
        parentId: this._task?.id,
        userId: userInfo!.id,
        subtype: visible,
        published: true,
        title: values.message,
        userData: {
          ...values,
          like,
          questionList: this.questionListForCreating,
        },
      };
      console.log(doc);
      const res = await M5APIs.createDocs(config.BUCKET_TASK!, [doc], "STOP");

      // 평가 생성 이후
      // AGGREGATION 쪽에 점수 정보 추가
      console.log(this.employee);
      const aggregationDocRes: any = await M5APIs.fetchDocById(
        this._employee.userData.aggregationId!,
        "",
        "AGGREGATION",
        {}
      );

      let aggUpdateDocs = {};

      //이미 평가를 했나 안했나로 업데이트를 다르게
      //이미 다른평가(공개면 비공개, 비공개면 공개)가 진행되었다고하면
      if (isDoneAssess) {
        if (aggregationDocRes.docs?.userData.assessList) {
          aggUpdateDocs = {
            type: "AGGREGATION",
            id: this._employee.userData.aggregationId,
            published: true,
            linkedIds: [
              ...aggregationDocRes.docs?.linkedIds,
              res.docs[0].parentId,
            ],
            userData: {
              assessList: [
                ...aggregationDocRes.docs?.userData.assessList,
                res.docs[0],
              ],
            },
          };
        } else {
          aggUpdateDocs = {
            type: "AGGREGATION",
            linkedIds: [res.docs[0].parentId],
            id: this._employee.userData.aggregationId,
            published: true,
            userData: {
              assessList: [res.docs[0]],
            },
          };
        }
      } else {
        if (aggregationDocRes.docs?.userData.assessList) {
          aggUpdateDocs = {
            type: "AGGREGATION",
            id: this._employee.userData.aggregationId,
            published: true,
            linkedIds: [
              ...aggregationDocRes.docs?.linkedIds,
              res.docs[0].parentId,
            ],
            userData: {
              assessList: [
                ...aggregationDocRes.docs?.userData.assessList,
                res.docs[0],
              ],
            },
          };
        } else {
          aggUpdateDocs = {
            type: "AGGREGATION",
            linkedIds: [res.docs[0].parentId],
            id: this._employee.userData.aggregationId,
            published: true,
            userData: {
              assessList: [res.docs[0]],
            },
          };
        }
      }

      await M5APIs.updateDocs(config.BUCKET_TASK!, [aggUpdateDocs], "MERGE");

      if (!isDoneAssess) {
        const userAggregationDocRes: any = await M5APIs.fetchDocById(
          userInfo.userData.aggregationId!,
          "",
          "AGGREGATION",
          {}
        );

        let userAggUpdateDocs = userAggregationDocRes.docs;

        console.log(userAggregationDocRes, userAggUpdateDocs);
        if (userAggUpdateDocs?.userData.doneList) {
          // 평가진행시 doneList가있을때

          // 평가진행시 doneList에 로그인한 유저의 AGGREGATION DOC에서 doneCount증가
          // doneList에 로그인한 유저의 값이 있다면
          if (
            userAggUpdateDocs?.userData.doneList.find(
              (done: AggregationDone) => done.user === this.employee?.id
            )
          ) {
            userAggUpdateDocs?.userData.doneList.forEach(
              (done: AggregationDone) => {
                if (done.user === this.employee?.id) {
                  if (
                    !this._task?.userData?.prvDoneIdList?.includes(
                      userInfo?.id
                    ) &&
                    !this._task?.userData?.pubDoneIdList?.includes(userInfo?.id)
                  ) {
                    done.count = done.count + 1;
                  }
                }
              }
            );

            userAggUpdateDocs.userData = {
              ...userAggUpdateDocs.userData,
              doneList: [...userAggregationDocRes.docs?.userData.doneList],
            };
          }
          // doneList에 로그인한 유저의 아이디가 없다면
          else {
            userAggUpdateDocs.userData = {
              ...userAggUpdateDocs.userData,
              doneList: [
                ...userAggregationDocRes.docs?.userData.doneList,
                { user: this.employee?.id, count: 1 },
              ],
            };
          }
        }
        //최초 평가진행시 doneList가없을때
        else {
          userAggUpdateDocs.userData = {
            ...userAggUpdateDocs.userData,
            doneList: [{ user: this.employee?.id, count: 1 }],
          };
        }

        console.log(userAggUpdateDocs);

        await M5APIs.updateDocs(
          config.BUCKET_TASK!,
          [userAggUpdateDocs],
          "MERGE"
        );
      }

      // 평가를 생성 한 이후에
      // 해당 TASK에 공개평가를 한적이 있는 ID는 userData.pubDoneIdList에
      // 비공개평가를 한적이 있는 ID는 userData.prvDoneIdList에 넣는다.
      let updateDocs = {};
      if (visible === "VISIBLE") {
        if (this._task?.userData?.pubDoneIdList) {
          updateDocs = {
            type: "TASK",
            id: this._task!.id,
            published: true,
            userData: {
              pubDoneIdList: [
                ...this._task?.userData?.pubDoneIdList,
                userInfo?.id,
              ],
            },
          };
        } else {
          updateDocs = {
            type: "TASK",
            id: this._task!.id,
            published: true,
            deleted: false,
            userData: {
              pubDoneIdList: [userInfo?.id],
            },
          };
        }
      } else {
        if (this._task?.userData?.prvDoneIdList) {
          updateDocs = {
            type: "TASK",
            id: this._task!.id,
            published: true,
            userData: {
              prvDoneIdList: [
                ...this._task?.userData?.prvDoneIdList,
                userInfo?.id,
              ],
            },
          };
        } else {
          updateDocs = {
            type: "TASK",
            id: this._task!.id,
            published: true,
            deleted: false,
            userData: {
              prvDoneIdList: [userInfo?.id],
            },
          };
        }
      }

      await M5APIs.updateDocs(config.BUCKET_TASK!, [updateDocs], "MERGE");
    } catch (error) {
      console.log(error);
    } finally {
      this._isLoading = false;
      this._submitted = true; // TODO:성공여부체크...
    }
  }

  @action
  async updateAssess(values: any, like: string, userInfo: UserModel) {
    try {
      console.log(values, like, userInfo);
      this._isLoading = true;

      //생성 할거 있으면 생성
      if (
        this._assess?.userData?.questionList &&
        this.createList.length !== 0
      ) {
        this._assess.userData.questionList = [
          ...this._assess.userData.questionList,
          ...this.createList,
        ];
      }

      // 수정 된거 있으면 수정
      if (this._assess?.userData?.questionList && this.editList.length !== 0) {
        for (let i = 0; i < this.editList.length; i++) {
          for (let j = 0; j < this._assess.userData.questionList.length; j++) {
            if (
              this.editList[i].id &&
              this.editList[i].id === this._assess.userData.questionList[j].id
            ) {
              this._assess.userData.questionList[j] = this.editList[i];
            }
            if (
              this.editList[i].tempId &&
              this.editList[i].tempId ===
                this._assess.userData.questionList[j].tempId
            ) {
              this._assess.userData.questionList[j] = this.editList[i];
            }
          }
        }
      }

      // 삭제 할거 있으면 삭제
      if (
        this._assess?.userData?.questionList &&
        this.deleteList.length !== 0
      ) {
        this._assess.userData.questionList =
          this._assess?.userData.questionList.filter(
            (question: QuestionModel) => {
              let flag = true;
              this.deleteList.forEach((li) => {
                if (question.tempId === li) {
                  flag = false;
                }
              });
              return flag;
            }
          );
      }

      let doc: any;
      if (this._assess?.userData.skip) {
        doc = {
          id: this._assess?.id,
          type: "ASSESS",
          published: true,
          title: values.message ? values.message : this._assess?.title,
          userData: {
            ...this._assess?.userData,
            ...values,
            like,
            uphistory: this._assess?.userData?.uphistory
              ? [...this._assess?.userData.uphistory, this._assess]
              : [this._assess],
            skip: false,
          },
        };
      } else {
        doc = {
          id: this._assess?.id,
          type: "ASSESS",
          published: true,
          title: values.message ? values.message : this._assess?.title,
          userData: {
            ...this._assess?.userData,
            ...values,
            like,
            uphistory: this._assess?.userData?.uphistory
              ? [...this._assess?.userData.uphistory, this._assess]
              : [this._assess],
          },
        };
      }

      console.log(doc);

      const res = await M5APIs.updateDocs(config.BUCKET_TASK!, [doc], "MERGE");

      console.log(res, userInfo);

      const aggregationDocRes: any = await M5APIs.fetchDocById(
        this._employee.userData.aggregationId!,
        "",
        "AGGREGATION",
        {}
      );

      console.log(aggregationDocRes);

      let aggUpdateDocs = {};

      for (
        let i = 0;
        i < aggregationDocRes.docs.userData.assessList.length;
        i++
      ) {
        if (
          aggregationDocRes.docs.userData.assessList[i].id === res.docs[0].id
        ) {
          aggregationDocRes.docs.userData.assessList[i] = res.docs[0];
        }
      }

      if (aggregationDocRes.docs.userData.assessList) {
        aggUpdateDocs = {
          type: "AGGREGATION",
          linkedIds: [
            ...aggregationDocRes.docs?.linkedIds,
            res.docs[0].parentId,
          ],
          id: this._employee.userData.aggregationId,
          published: true,
          userData: {
            assessList: aggregationDocRes.docs?.userData.assessList,
          },
        };
      }

      await M5APIs.updateDocs(config.BUCKET_TASK!, [aggUpdateDocs], "MERGE");
    } catch (error) {
      console.log(error);
    } finally {
      this._isLoading = false;
      this._submitted = true; // TODO:성공여부체크...
    }
  }

  @action
  setIsHTMLOpen(isHTMLOpen: boolean) {
    this._isHTMLOpen = isHTMLOpen;
  }

  @action
  setIsOpenModal(isOpenModal: boolean) {
    this._isOpenModal = isOpenModal;
  }

  @action
  setEmployee(employee: EmployeeModel) {
    this._employee = employee;
  }
  @action
  setTask(task: TaskModel) {
    this._task = task;
  }

  @action
  setScore(score: string) {
    this._score = score;
  }

  @action
  setEmoji(emoji: string) {
    this._emoji = emoji;
  }

  @action
  setAssess(assess: AssessModel) {
    this._score = assess.userData?.grade + "";
    if (assess.userData.emoticon) {
      this._emoji = assess.userData.emoticon;
    }

    this._assess = assess;
  }

  @action
  // TODO: any 수정
  setFormik(formik: any) {
    this._formik = formik;
  }

  @action
  setFomikValue(values: any) {
    this._formik.setFieldValue("emoticon", values.emoticon);
  }

  @action
  setIsLoading(isLoading: boolean) {
    this._isLoading = isLoading;
  }

  @action
  setSubmitted(submitted: boolean) {
    this._submitted = submitted;
  }

  @action
  setUpdateMode(updateMode: boolean) {
    this._updateMode = updateMode;
  }

  @action
  setIsCloseModal(isCloseModal: boolean) {
    this._isCloseModal = isCloseModal;
  }

  @action
  setIsQusetionModal(isQusetionModal: boolean) {
    this._isQusetionModal = isQusetionModal;
  }

  @computed
  get isQusetionModal() {
    return this._isQusetionModal;
  }

  @computed
  get isOpenModal() {
    return this._isOpenModal;
  }
  @computed
  get isCloseModal() {
    return this._isCloseModal;
  }

  @computed
  get updateMode() {
    return this._updateMode;
  }
  @computed
  get employee() {
    return this._employee;
  }

  @computed
  get task() {
    return this._task;
  }
  @computed
  get formik() {
    return this._formik;
  }

  @computed
  get isLoading() {
    return this._isLoading;
  }

  @computed
  get submitted() {
    return this._submitted;
  }

  @computed
  get questionList() {
    console.log("@@@", this._questionList);
    return this._questionList;
  }

  @computed
  get customQuestionList() {
    return this._customQuestionList;
  }

  @computed
  get assess() {
    return this._assess;
  }

  @computed
  get score() {
    return this._score;
  }

  @computed
  get emoji() {
    return this._emoji;
  }

  @computed
  get isHTMLOpen() {
    return this._isHTMLOpen;
  }
}

export default TaskGradeEditPageStore;
